import { Box, Typography } from "@mui/material";
import DateWithUnderline from "./DateWithUnderline";
import EmployeeNameComponent from "./EmployeeNameComponent";

const SignBox = ({ created_by, created_date, text, documentType }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 600,
        mb:
          created_by?.has_e_signature && created_by?.e_signature_img_url
            ? 0
            : 6.5,
      }}
    >
      {text}
    </Typography>
    {created_by?.has_e_signature && created_by?.e_signature_img_url && (
      <img
        alt={created_by?.e_signature_img_url}
        src={created_by?.e_signature_img_url}
        style={{
          display: "block",
          marginTop: "8px",
          width: 90,
          height: 45,
          objectFit: "contain",
        }}
        // Revoke data uri after image is loaded
      />
    )}
    <EmployeeNameComponent employee={created_by} />
    <DateWithUnderline
      created_date={created_date}
      documentType={documentType}
    />
  </Box>
);
export default SignBox;
